import { render, staticRenderFns } from "./StudentFamilyIncome.vue?vue&type=template&id=55423938&"
import script from "./StudentFamilyIncome.js?vue&type=script&lang=js&"
export * from "./StudentFamilyIncome.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports